import { AdCopyReviewController } from '@controllers/admin/ad-copy-review-controller';
import { CampaignSearchController } from '@controllers/admin/campaign-search-controller';
import { AdminHelpAndSupportController } from '@controllers/admin/help-and-support-controller';
import { AdminInvoicesController } from '@controllers/admin/invoices-controller';
import { PartnerOverviewController } from '@controllers/admin/partner-overview-controller';
import { PartnerProductsController } from '@controllers/admin/partner-products-controller';
import { PaymentProfilesController } from '@controllers/admin/payment-profiles-controller';
import { RejectAdCopyController } from '@controllers/admin/reject-ad-copy-controller';
import { ErrorController } from '@controllers/common/error-controller';
import { LandingPageController } from '@controllers/common/landing-page-controller';
import { LogoutController } from '@controllers/common/logout-controller';
import { OnboardHelpAndSupportController } from '@controllers/common/onboard-help-and-support-controller';
import { SelectAccountController } from '@controllers/common/select-account-controller';
import { CampaignManagementController } from '@controllers/partner/campaign-management-controller';
import { CampaignWizardController } from '@controllers/partner/campaign-wizard-controller';
import { HelpAndSupportController } from '@controllers/partner/help-and-support-controller';
import { InvoicesController } from '@controllers/partner/invoices-controller';
import { OnboardingController } from '@controllers/partner/onboarding-controller';
import { ReportingController } from '@controllers/partner/reporting-controller';
import { UsersController } from '@controllers/partner/users-controller';
import { ViewAndManageController } from '@controllers/partner/view-and-manage-controller';

import { AdvertiserEmailSettingsController } from './partner/advertiser-email-settings-controller';
import { ChangeHistoryController } from './partner/change-history-controller';

// IMPORTANT
// Set controllers in the order they need to appear in sidebar

const partnerControllers = [
  CampaignManagementController,
  ReportingController,
  ChangeHistoryController,
  InvoicesController,
  HelpAndSupportController,
  UsersController,
  OnboardingController,
  CampaignWizardController,
  ViewAndManageController,
  AdvertiserEmailSettingsController,
  OnboardHelpAndSupportController,
];
const adminControllers = [
  CampaignSearchController,
  AdCopyReviewController,
  RejectAdCopyController,
  AdminInvoicesController,
  AdminHelpAndSupportController,
  PartnerOverviewController,
  PartnerProductsController,
  PaymentProfilesController,
];

export const controllers = [
  ErrorController,
  LandingPageController,
  LogoutController,
  SelectAccountController,
  ...partnerControllers,
  ...adminControllers,
];

export const legacyControllerPaths = [
  '/notification-settings',
  '/campaigns',
  '/campaign-wizard',
  '/change-history',
  '/onboarding',
  '/help',
  '/invoices',
  '/reporting',
  '/users',
  '/view-and-manage',
];
